



























import { Component, Mixins, Vue } from "vue-property-decorator";
import GlobalMixin from "@/shared/mixins/global-mixin";

@Component
export default class CookiesBanner extends Mixins(GlobalMixin) {
  private displayBanner = false;

  private get onQuestionnaire() {
    // are we on a classic questionnaire, if not we are on conversational questionnaire
    const path = window.location.pathname;
    const onQuestionnaire = path.includes("360") || path.includes("esg") || path.includes("modulable");
    return onQuestionnaire;
  }

  public pressedOk() {
    // Consent for 2 months
    const consent = {
      ad_storage: 'granted',
      analytics_storage: 'granted',
      functionality_storage: 'granted',
      security_storage: 'granted',
    };
    this.$cookies.set("cookie_choice_opt", consent, 60 * 60 * 24 * 30 * 2);
    this.displayBanner = false;
    this.startGtagTracking(consent);
    if (this.onQuestionnaire) this.removeOffset();
  }

  private async addOffset() {
    // need offset on transition page on ESG and 360
    let count = 0;
    while (document.getElementById("transi-page") == null) {
      // have to wait for chrome..
      await new Promise((r) => setTimeout(r, 500));
    }
    const transiPage = document.getElementById("transi-page");
    setTimeout(() => {
      // add margin to transi page on 360 and ESG when cookies banner is displayed
      const transiPage = document.getElementById("transi-page");
      if (transiPage) transiPage.classList.add("cookies-offset");
    }, 1000);
  }

  private removeOffset() {
    // remove offset on TransitionPage after hiding banner
    const transiPage = document.getElementById("transi-page"); // on template TransitionPage
    if (!transiPage) return;
    const hasOffset = transiPage.classList.contains("cookies-offset"); // needs an offset to avoid banner hiding buttons
    if (hasOffset) {
      transiPage.classList.remove("cookies-offset"); //once banner disappears, remove offset
      return;
    }
  }

  public async mounted() {
    let cookie = this.$cookies.get("cookie_choice_opt");
    if (cookie == null) {
      this.displayBanner = true;
      if (this.onQuestionnaire) {
        this.addOffset();
      }
    }
  }
}
